(() => {
  'use strict';
  if (window.grandAgeSelectsReady) return;
  window.grandAgeSelectsReady = true;
  function enhance(root = document) {
    root.querySelectorAll('[data-grand-age-gate] select').forEach(select => {
      if (select.dataset.enhanced) return;
      const label = select.parentElement;
      const field = document.createElement('div');
      field.className = 'grand-age-field';
      const caption = label.querySelector('span');
      const id = `grand-age-${select.name}`;
      caption.id = `${id}-label`;
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'grand-age-select';
      trigger.id = `${id}-trigger`;
      trigger.setAttribute('role', 'combobox');
      trigger.setAttribute('aria-labelledby', caption.id);
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-required', 'true');
      trigger.setAttribute('aria-controls', `${id}-options`);
      const list = document.createElement('div');
      list.id = `${id}-options`;
      list.className = 'grand-age-options';
      list.setAttribute('role', 'listbox');
      list.setAttribute('aria-labelledby', caption.id);
      list.hidden = true;
      const options = Array.from(select.options).filter(option => !option.disabled && option.value);
      const items = options.map((option, index) => {
        const item = document.createElement('div');
        item.id = `${id}-option-${index}`;
        item.setAttribute('role', 'option');
        item.setAttribute('aria-selected', String(option.selected));
        item.textContent = option.textContent;
        list.append(item);
        item.addEventListener('pointerdown', event => event.preventDefault());
        item.addEventListener('click', () => commit(index));
        return item;
      });
      let active = -1;
      let buffer = '';
      let typedAt = 0;
      const sync = () => {
        trigger.textContent = select.options[select.selectedIndex]?.textContent || '';
        items.forEach((item, index) => item.setAttribute('aria-selected', String(options[index].value === select.value)));
      };
      const close = () => {
        list.hidden = true;
        field.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.removeAttribute('aria-activedescendant');
      };
      const activate = index => {
        active = Math.max(0, Math.min(items.length - 1, index));
        items.forEach((item, i) => item.classList.toggle('is-highlighted', i === active));
        trigger.setAttribute('aria-activedescendant', items[active].id);
        const item = items[active];
        if (item.offsetTop < list.scrollTop) list.scrollTop = item.offsetTop;
        else if (item.offsetTop + item.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = item.offsetTop + item.offsetHeight - list.clientHeight;
      };
      const position = () => {
        if (list.hidden) return;
        const viewport = window.visualViewport;
        const bottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
        const room = bottom - trigger.getBoundingClientRect().bottom - 24;
        list.style.maxHeight = `${Math.max(80, Math.min(window.innerWidth <= 600 ? 190 : 220, room))}px`;
      };
      const open = () => {
        select.closest('[data-grand-age-gate]').querySelectorAll('.grand-age-select').forEach(other => {
          if (other !== trigger) other.dispatchEvent(new Event('grand:select-close'));
        });
        list.hidden = false;
        field.classList.add('is-open');
        position();
        trigger.setAttribute('aria-expanded', 'true');
        activate(Math.max(0, options.findIndex(option => option.value === select.value)));
      };
      function commit(index) {
        select.value = options[index].value;
        select.dispatchEvent(new Event('change', {bubbles:true}));
        sync(); close(); trigger.focus({preventScroll:true});
      }
      trigger.addEventListener('click', () => list.hidden ? open() : close());
      trigger.addEventListener('grand:select-close', close);
      trigger.addEventListener('grand:select-position', position);
      trigger.addEventListener('blur', close);
      trigger.addEventListener('keydown', event => {
        const key = event.key;
        if (key === 'Escape') { if (!list.hidden) { event.preventDefault(); event.stopPropagation(); close(); } return; }
        if (key === 'Tab') { close(); return; }
        if (['Enter',' '].includes(key)) { event.preventDefault(); list.hidden ? open() : commit(active); return; }
        if (['ArrowDown','ArrowUp','Home','End'].includes(key)) {
          event.preventDefault();
          const wasClosed = list.hidden;
          if (wasClosed) open();
          if (key === 'Home') activate(0);
          else if (key === 'End') activate(items.length - 1);
          else if (!wasClosed) activate(active + (key === 'ArrowDown' ? 1 : -1));
          return;
        }
        if (/^[0-9]$/.test(key)) {
          event.preventDefault();
          if (list.hidden) open();
          buffer = Date.now() - typedAt > 800 ? key : buffer + key;
          typedAt = Date.now();
          let found = options.findIndex(option => option.textContent.trim().startsWith(buffer));
          if (found < 0) { buffer = key; found = options.findIndex(option => option.textContent.trim().startsWith(buffer)); }
          if (found >= 0) activate(found);
        }
      });
      select.addEventListener('change', sync);
      select.dataset.enhanced = 'true';
      select.hidden = true;
      select.tabIndex = -1;
      label.replaceWith(field);
      field.append(caption, select, trigger, list);
      sync();
    });
  }
  document.addEventListener('pointerdown', event => {
    const inside = event.target.closest('.grand-age-field');
    document.querySelectorAll('.grand-age-field.is-open').forEach(field => {
      if (field !== inside) field.querySelector('.grand-age-select').dispatchEvent(new Event('grand:select-close'));
    });
  });
  const reposition = () => document.querySelectorAll('.grand-age-field.is-open .grand-age-select').forEach(trigger => trigger.dispatchEvent(new Event('grand:select-position')));
  window.addEventListener('resize', reposition);
  window.visualViewport?.addEventListener('resize', reposition);
  document.addEventListener('scroll', event => {
    if (event.target.matches?.('[data-grand-age-gate]')) reposition();
  }, true);
  enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  document.addEventListener('shopify:section:deselect', event => event.target.querySelectorAll('.grand-age-select').forEach(trigger => trigger.dispatchEvent(new Event('grand:select-close'))));
})();
